import { extendTheme } from '@chakra-ui/react'
import Button from './components/button'
import theme from './GlobalStyles'


const config = {
    initialColorMode: 'light',
    useSystemColorMode: false,
  }
  

const overrides = {
    config,
    fonts: {
        heading: `'Inter', sans-serif`,
        body: `'Inter', sans-serif`,
        paragraph :`'Inter', sans-serif`,
      },
    theme,
    components: {
        Button,
    },
}

export default extendTheme(overrides)